import { staticImplementsDecorator } from '@mkx/decorators/static-implements.decorator';
import { ApiResponseEntityBuilderInterface } from '@mkx/interfaces/common/api-response-entity-builder.interface';
import { Expose, plainToInstance } from 'class-transformer';
import 'reflect-metadata';
import { SelectOptionInterface } from '@mkx/interfaces/common/select-option.interface';
import { IconModel } from '@mkx/models/icon.model';

@staticImplementsDecorator<ApiResponseEntityBuilderInterface>()
export class CompanyModel implements SelectOptionInterface<CompanyModel> {
  private selected = false;

  @Expose({ groups: ['read', 'post', 'put'], name: 'id' })
  private id: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'name' })
  private name: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'address' })
  private address: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'vat_number' })
  private vatNumber: string;

  @Expose({ groups: ['read', 'post', 'put'], name: 'currency' })
  private currency: string;

  static buildFromAPIResponse(body: any): any {
    return plainToInstance(CompanyModel, body, { groups: ['read'] });
  }

  public getId(): string {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getAddress(): string {
    return this.address;
  }

  public getVatNumber(): string {
    return this.vatNumber;
  }

  public getCurrency(): string {
    return this.currency;
  }

  selectOptionGetColorClass(): string | null {
    return undefined;
  }

  selectOptionGetDescription(): string | null {
    return this.vatNumber;
  }

  selectOptionGetIcon(): IconModel | null {
    return undefined;
  }

  selectOptionGetIdentifier(): any {
    return this.id;
  }

  selectOptionGetLabel(): string {
    return this.name;
  }

  selectOptionGetLabelProperty(): string {
    return 'name';
  }

  selectOptionGetValue(): CompanyModel {
    return this;
  }

  selectOptionIsDisabled(): boolean {
    return false;
  }

  selectOptionLabelIsUrl(): boolean {
    return false;
  }

  selectOptionSelect() {
    this.selected = true;
  }

  selectOptionDeselect() {
    this.selected = false;
  }

  selectOptionIsSelected(): boolean {
    return this.selected;
  }
}
